import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Expense } from "../state/types"

export const useExpenseActions = () => {
    const saveActions = useSaveActions()

    const saveExpense = (expense: Expense) => {
        const { save } = saveActions()
        return save(TableName.EXPENSES, expense) as Promise<Expense>
    }

    const removeExpense = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.EXPENSES, id)
    }

    return {
        saveExpense,
        removeExpense
    }
}
